// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"920":"944dc62455130c27e712","921":"10ab3386492af8ef6243"}[chunkId] + ".css";
};